module.exports = __webpack_public_path__ + "static/media/Dark-theme.66b91fae.png";